import { render, staticRenderFns } from "./statisticFieldPopover.vue?vue&type=template&id=1e3c82c1&scoped=true"
import script from "./statisticFieldPopover.vue?vue&type=script&lang=js"
export * from "./statisticFieldPopover.vue?vue&type=script&lang=js"
import style0 from "./statisticFieldPopover.vue?vue&type=style&index=0&id=1e3c82c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3c82c1",
  null
  
)

export default component.exports